import type React from 'react';
import { COUNTRY, countryEnumBase, EnumHelperBase, type CountryEnumBaseData, type CountryEnumBaseExtraData } from '@nfctron/nexus-core';
import {
	AustriaFlagIcon,
	BelgiumFlagIcon,
	BulgariaFlagIcon,
	CroatiaFlagIcon,
	CyprusFlagIcon,
	CzechiaFlagIcon,
	DenmarkFlagIcon,
	EstoniaFlagIcon,
	FinlandFlagIcon,
	FranceFlagIcon,
	GermanyFlagIcon,
	GreatBritainFlagIcon,
	GreeceFlagIcon,
	HungaryFlagIcon,
	IcelandFlagIcon,
	IrelandFlagIcon,
	ItalyFlagIcon,
	LatviaFlagIcon,
	LiechtensteinFlagIcon,
	LithuaniaFlagIcon,
	LuxembourgFlagIcon,
	MaltaFlagIcon,
	NetherlandsFlagIcon,
	NorwayFlagIcon,
	PolandFlagIcon,
	PortugalFlagIcon,
	RomaniaFlagIcon,
	SerbiaFlagIcon,
	SlovakiaFlagIcon,
	SloveniaFlagIcon,
	SpainFlagIcon,
	SwedenFlagIcon,
	SwitzerlandFlagIcon,
} from '@nfctron/nexus-react-svg';

export interface CountryEnumReactExtraDataExtend {
	Icon: React.FC<React.SVGProps<SVGElement>>;
}

export interface CountryEnumReactData extends CountryEnumBaseData, CountryEnumReactExtraDataExtend {}

/**
 * Country enumeration with extra data for React
 * @extends CountryEnumBase Base country enumeration
 */
class CountryEnumReact extends EnumHelperBase<
	CountryEnumBaseExtraData,
	COUNTRY,
	typeof countryEnumBase.enumName,
	typeof countryEnumBase.idKey,
	CountryEnumReactExtraDataExtend
> {
	constructor() {
		super(countryEnumBase.enumName, countryEnumBase.data, countryEnumBase.idKey, {
			[COUNTRY.CZE]: { Icon: CzechiaFlagIcon },
			[COUNTRY.SVK]: { Icon: SlovakiaFlagIcon },
			[COUNTRY.AUT]: { Icon: AustriaFlagIcon },
			[COUNTRY.GBR]: { Icon: GreatBritainFlagIcon },
			[COUNTRY.SRB]: { Icon: SerbiaFlagIcon },
			[COUNTRY.BEL]: { Icon: BelgiumFlagIcon },
			[COUNTRY.BGR]: { Icon: BulgariaFlagIcon },
			[COUNTRY.HRV]: { Icon: CroatiaFlagIcon },
			[COUNTRY.CYP]: { Icon: CyprusFlagIcon },
			[COUNTRY.DNK]: { Icon: DenmarkFlagIcon },
			[COUNTRY.EST]: { Icon: EstoniaFlagIcon },
			[COUNTRY.FIN]: { Icon: FinlandFlagIcon },
			[COUNTRY.FRA]: { Icon: FranceFlagIcon },
			[COUNTRY.DEU]: { Icon: GermanyFlagIcon },
			[COUNTRY.GRC]: { Icon: GreeceFlagIcon },
			[COUNTRY.HUN]: { Icon: HungaryFlagIcon },
			[COUNTRY.IRL]: { Icon: IrelandFlagIcon },
			[COUNTRY.ITA]: { Icon: ItalyFlagIcon },
			[COUNTRY.LVA]: { Icon: LatviaFlagIcon },
			[COUNTRY.LTU]: { Icon: LithuaniaFlagIcon },
			[COUNTRY.LUX]: { Icon: LuxembourgFlagIcon },
			[COUNTRY.MLT]: { Icon: MaltaFlagIcon },
			[COUNTRY.POL]: { Icon: PolandFlagIcon },
			[COUNTRY.PRT]: { Icon: PortugalFlagIcon },
			[COUNTRY.ROU]: { Icon: RomaniaFlagIcon },
			[COUNTRY.SVN]: { Icon: SloveniaFlagIcon },
			[COUNTRY.ESP]: { Icon: SpainFlagIcon },
			[COUNTRY.SWE]: { Icon: SwedenFlagIcon },
			[COUNTRY.NLD]: { Icon: NetherlandsFlagIcon },
			[COUNTRY.ISL]: { Icon: IcelandFlagIcon },
			[COUNTRY.LIE]: { Icon: LiechtensteinFlagIcon },
			[COUNTRY.NOR]: { Icon: NorwayFlagIcon },
			[COUNTRY.CHE]: { Icon: SwitzerlandFlagIcon },
		});
	}
}

export const countryEnumReact = new CountryEnumReact();
